// SystemOverview.jsx
import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import ClientView from './ClientSection/SiteView';
import AddClient from './ClientSection/AddClient';
import Navigationbar from './Navigationbar';

const SystemOverview = () => {
  const { menu } = useParams();
  const [activeMenu, setActiveMenu] = useState(menu || 'addSite'); // default to 'home'
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };

  return (
    <div className="system-overview-page">
        {/* <Navigationbar /> */}
      <div className="sidebar">
        <ul>
        <li style={{borderBlock:'1px solid white'}}>
            Site Management
          </li><br/>
          <li className={activeMenu === 'addSite' ? 'active' : ''} onClick={() => handleMenuClick('addSite')}>
            <Link to="/client-portal/addSite">Add New Site</Link>
          </li>
          <li className={activeMenu === 'SiteView' ? 'active' : ''} onClick={() => handleMenuClick('SiteView')}>
            <Link to="/client-portal/SiteView"> Site Management</Link>
          </li>
        </ul>
      </div>

      <div className="system-overview-page-content">
        
        {activeMenu === 'SiteView' && <ClientView />}
        {/* {activeMenu === 'addSite' && <AddClient />} */}
        {activeMenu === 'addSite' && !activeSubmenu && <AddClient />}
        {/* {activeMenu === 'devices' && !activeSubmenu && <ShowDevices />}
        {activeMenu === "devices" && activeSubmenu === "showDevices" && <ShowDevices />}
        {activeMenu === "devices" && activeSubmenu === "addDevice" && <AddDevices />} */}
        {/* {activeSubmenu === 'By Clients' && <ReportsContent />}  */}
      </div>
    </div>
  );
};

export default SystemOverview;
